export default __webpack_public_path__ + "static/media/cone_indicator_icon.c191f958.svg";